module.exports = __webpack_public_path__ + "static/media/vf-button-dress.ba0a6ff2.svg";